import httpClient from '../httpClient';
import { logTrackingEvent } from './trackingService';

export const getCartList = async (idCustomer, zipcode, idStore) => {
  const result = await httpClient.get('/cart/get', {
    params: {
      idCustomer: idCustomer,
      zipcode: zipcode,
      idStore: idStore,
    },
  });
  return result.data;
};
export const addCart = async (idCustomer, idStyle, color, totQty) => {
  const result = await httpClient.get('/cart/add', {
    params: {
      idCustomer: idCustomer,
      idStyle: idStyle,
      color: color,
      totQty: totQty,
    },
  });

  if (result.data?.is_success) {
    logTrackingEvent({
      sessionId: sessionStorage.getItem('edenTrackingSessionId') || null,
      eventType: 'ADD_TO_CART',
      path:
        window.location.pathname +
        window.location.search +
        window.location.hash,
      idCustomer,
      idStyle,
      quantity: totQty,
      payloadJson: {
        color: color || null,
      },
    }).catch((err) => {
      console.error('Failed to log add-to-cart event:', err);
    });
  }

  return result.data;
};
export const updateCart = async (
  idCustomer,
  zipcode,
  idStyle,
  idStyleDtl,
  totQty,
) => {
  const result = await httpClient.get('/cart/set', {
    params: {
      idCustomer: idCustomer,
      idStyle: idStyle,
      idStyleDtl: idStyleDtl,
      zipcode: zipcode,
      totQty: totQty,
    },
  });
  return result.data;
};
export const removeCart = async (idCustomer, idCartDtl) => {
  const result = await httpClient.get('/cart/remove', {
    params: {
      idCustomer: idCustomer,
      idCartDtl: idCartDtl,
    },
  });
  return result.data;
};

export const getCartShippingMethod = async (idCustomer) => {
  const result = await httpClient.get('/cart/shipping-method', {
    params: {
      idCustomer: idCustomer,
    },
  });
  return result.data;
};
